import { Subject } from "rxjs";
import ky, { HTTPError } from "ky";
import { STORAGE_KEYS } from "@/lib/constants";
import qs from "query-string";

const errorEvent$ = new Subject<HTTPError<unknown>>();
export const errorEvent = errorEvent$.asObservable();

const kyInstance = ky.create({
  prefixUrl: import.meta.env.VITE_API_URL,
  retry: 0,
  timeout: 3 * 60 * 1000,
  hooks: {
    beforeRequest: [
      (request) => {
        const accessToken = localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
        if (accessToken) {
          request.headers.set("partner-token", accessToken);
        }
      },
    ],
    beforeError: [
      async (error) => {
        console.error(error);
        errorEvent$.next(error);
        return error;
      },
    ],
  },
});

const kyInstanceHeimdall = ky.create({
  prefixUrl: import.meta.env.VITE_HEIMDALL_API_URL,
  retry: 0,
  timeout: 3 * 60 * 1000,
  hooks: {
    beforeRequest: [
      (request) => {
        const accessToken = localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
        if (accessToken) {
          request.headers.set("heimdall-token", accessToken);
        }
      },
    ],
    beforeError: [
      async (error) => {
        console.error(error);
        errorEvent$.next(error);
        return error;
      },
    ],
  },
});

export const cleanSearchParams = (searchParams: Record<string, unknown>) => {
  return qs.stringify(searchParams, {
    skipEmptyString: true,
    skipNull: true,
  });
};

export const fetcher = async (url: string) => {
  const response = await kyInstance.get(url);
  return response.json();
};

export const API = kyInstance;
export const HEIMDALL_API = kyInstanceHeimdall;
